import axios from 'axios'
import {  Message } from 'element-ui'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, 
  timeout: 50000
})


service.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)


service.interceptors.response.use(
  response => {
    const res = response.data
    if (!res.code) return res
    if (res.code !== 200) {
      // Message({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      // return Promise.reject(new Error(res.message || res.msg || 'Error'))
      return Promise.resolve();
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    // return Promise.reject(error)
    return Promise.resolve();
  }
)

export default service
